import React from 'react'
import ReactDOM from 'react-dom/client'
import { LanguageProvider } from 'context/languageContext'
import App from './App'
import './index.css'
import './animations.css'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
)
